import { useEffect } from 'react'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import { useSignIn, useSignUp} from '@clerk/clerk-react'
import Loading from '@/components/Loading'
import { useRedirectToLastUrl } from '@/hooks/useRedirectToLastUrl'
import {logger} from "@/logger/logger";

function SsoCallback() {
  const { created_session_id } = Route.useSearch()
  const navigate = useNavigate()
  const { isLoaded, setActive, signIn } = useSignIn()
  const { signUp } = useSignUp()
  useRedirectToLastUrl()

  useEffect(() => {
    if (!isLoaded) return

    const func = async () => {
      logger.info('SSO flow started', {created_session_id})
      if (created_session_id) {
        await setActive({ session: created_session_id })
      } else {
        logger.info('reloading sign in to get session id?')
        await signIn.reload()
        const { status, firstFactorVerification, createdSessionId } = signIn
        logger.info('Signin Reloaded', {status, firstFactorVerification, createdSessionId})
        if (status === 'complete' && createdSessionId) {
          await setActive({ session: createdSessionId })
        } else if (firstFactorVerification.status === 'transferable') {
          logger.info('Transfering to signup')
          const signUpResult = await signUp?.create({ transfer: true })
          logger.info('Signup results', { signUpResult })
          if (signUpResult?.status === "complete") {
            await setActive({ session: signUpResult.createdSessionId! })
          } else {
            logger.info('No good, redirecting to login')
            void navigate({ to: '/login', replace: true })
          }
        } else {
          throw new Error('SSO Callback Error: cannot sign in and not transferable')
        }
      }
    }

    void func().catch((error) => logger.error(error))
  }, [created_session_id, isLoaded])

  return <Loading />
}

export const Route = createFileRoute('/sso-callback')({
  validateSearch: (search: Record<string, unknown>) => ({
    created_session_id: search.created_session_id as string | undefined,
  }),
  component: SsoCallback,
})
